import { render } from "./CompanyFounderCard.vue?vue&type=template&id=5a63836d"
import script from "./CompanyFounderCard.vue?vue&type=script&lang=js"
export * from "./CompanyFounderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__